import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { BlobService } from '@volt/shared/services/blob.service';
import { map, tap } from 'rxjs/operators';
import { APPLICATION_CONFIGURATION, ApplicationConfiguration } from '../../../../configuration';

@Pipe({
  name: 'secureUrl',
})
export class SecureUrlPipe implements PipeTransform {
  constructor(
    private readonly _blobService: BlobService,
    @Inject(APPLICATION_CONFIGURATION) private _appConfig: ApplicationConfiguration,
  ) {}

  transform(url: string): Observable<string> {
    if (!this._blobService.referencesVoltBlob(url)) {
      return of(url);
    }

    const blobPath = `${this._appConfig.blobUrl}/`;
    if (url.startsWith(blobPath)) {
      url = url.replace(blobPath, '');
    }

    if (this._blobService.isSecured(url)) {
      const container = url.match(/[a-zA-Z1-9]*/)[0];
      const regex = new RegExp(container + '/\\$path');
      return this._blobService.getContainerSasTokenWithRefresh(container).pipe(
        map(result => {
          const urlPath = url.split('?')[0];
          const urlSearch = new URLSearchParams(url.split('?')[1]);
          const returnUrl = new URL(result.replace(regex, urlPath));
          urlSearch.forEach((value, key) => {
            returnUrl.searchParams.set(key, value);
          });
          return returnUrl.toString();
        }),
        tap(finalResult => console.log('SecureUrl.transform end', finalResult)),
      );
    }

    url = this._blobService.getFullUrl(url);
    console.log('SecureUrl insecure url', url);
    return of(url);
  }
}
